import {useState, useEffect} from "react";
import {getEnvAPI, getOrders} from "../../../utils/ordersControlar";

const useAuthToken = (setTodayOrders, setSystemData) => {
    const [systemLogin, setSystemLogin] = useState(false);
    const [loading, setLoading] = useState(true);

    const checkAuthentication = async () => {
        if (systemLogin !== false)
            return null;
        const token = localStorage.getItem("token");
        let store = null;
        if (token) {
            const newData = await getEnvAPI();
            if (newData?.error === 0) {
                store = newData.store;
                setSystemData(newData.store);
                setSystemLogin(true);
            } else {
                setSystemLogin(false);
            }
        } else {
            setSystemLogin(false);
        }
        setLoading(false);
        return store;
    };

    useEffect(() => {
        checkAuthentication();
    }, [systemLogin]);

    return {systemLogin, loading, setSystemLogin, checkAuthentication};
};

export default useAuthToken;
